import request from '../request'

export function fetchList(params) {
    return request({
        url: '/market-service/supplier/list',
        params
    })
}

export function add(data) {
    return request({
        url: '/market-service/supplier/add',
        method: 'POST',
        data,
    })
}

export function fetchDetail(params) {
    return request({
        url: `/market-service/supplier/detail/${params.id}`,
    })
}

export function edit(data) {
    return request({
        url: '/market-service/supplier/update',
        method: 'POST',
        data,
    })
}

export function remove(data) {
    return request({
        url: '/market-service/supplier/delete',
        method: 'POST',
        data
    })
}